/* GOGETTERS stroomanimatie.
   Tekent lijnen van de platformtegels (links) naar het logo en van het logo naar de
   leverancierstegels (rechts), gemeten vanuit de echte DOM-posities. Gouden orders
   lopen van links naar rechts, donkere producten van rechts naar links. Op mobiel
   (CSS-variabele --gg-stroom-mode: vertical) lopen de lijnen van boven naar beneden.
   Werkt ook in de Shopify-themabewerker (section:load / unload). */
(function () {
  'use strict';

  var instances = new Map();

  function init(root) {
    if (instances.has(root)) return;
    var cv = root.querySelector('.gg-stroom-canvas');
    if (!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var core = root.querySelector('.gg-stroom-core');
    var leftTiles = [], rightTiles = [];
    var W = 0, H = 0, DPR = 1;
    var pathsL = [], pathsR = [];
    var parts = [], acc = 0, dashOff = 0, last = 0, t0 = 0, raf = 0, alive = true;
    var pal = {};
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = (parseFloat(root.dataset.speed) || 100) / 100;
    var density = (parseFloat(root.dataset.density) || 100) / 100;

    function readPalette() {
      var cs = getComputedStyle(root);
      pal = {
        line: cs.getPropertyValue('--gg-stroom-line').trim(),
        comet: cs.getPropertyValue('--gg-stroom-comet').trim(),
        product: cs.getPropertyValue('--gg-stroom-product').trim(),
        order: cs.getPropertyValue('--gg-stroom-order').trim(),
        grid: cs.getPropertyValue('--gg-stroom-grid').trim(),
        blend: cs.getPropertyValue('--gg-stroom-blend').trim() || 'source-over',
        glow: parseFloat(cs.getPropertyValue('--gg-stroom-glow')) || 0
      };
    }

    function rel(el) {
      var r = el.getBoundingClientRect(), b = root.getBoundingClientRect();
      return { l: r.left - b.left, t: r.top - b.top, r: r.right - b.left, b: r.bottom - b.top, cx: r.left - b.left + r.width / 2, cy: r.top - b.top + r.height / 2 };
    }

    function layout() {
      W = root.clientWidth; H = root.clientHeight; DPR = Math.min(2, window.devicePixelRatio || 1);
      cv.width = W * DPR; cv.height = H * DPR; ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      leftTiles = Array.prototype.slice.call(root.querySelectorAll('.gg-stroom-tile[data-side="left"]'));
      rightTiles = Array.prototype.slice.call(root.querySelectorAll('.gg-stroom-tile[data-side="right"]'));
      var c = rel(core), gap = 10;
      var vertical = (getComputedStyle(root).getPropertyValue('--gg-stroom-mode').trim() === 'vertical');
      if (vertical) {
        /* platformen boven, leveranciers onder: van tegel-onderkant naar logo-bovenkant en van logo-onderkant naar tegel-bovenkant */
        var Tc = { x: c.cx, y: c.t - gap }, Bc = { x: c.cx, y: c.b + gap };
        pathsL = leftTiles.map(function (el) { var q = rel(el); var s = { x: q.cx, y: q.b + 4 }; var my = (s.y + Tc.y) / 2; return [s, { x: s.x, y: my + 18 }, { x: Tc.x, y: my - 18 }, Tc]; });
        pathsR = rightTiles.map(function (el) { var q = rel(el); var e = { x: q.cx, y: q.t - 4 }; var my = (Bc.y + e.y) / 2; return [Bc, { x: Bc.x, y: my + 18 }, { x: e.x, y: my - 18 }, e]; });
      } else {
        var Lc = { x: c.l - gap, y: c.cy }, Rc = { x: c.r + gap, y: c.cy };
        pathsL = leftTiles.map(function (el) { var q = rel(el); var s = { x: q.r + 6, y: q.cy }; var cx = (s.x + Lc.x) / 2; return [s, { x: cx + 30, y: s.y }, { x: cx - 30, y: Lc.y }, Lc]; });
        pathsR = rightTiles.map(function (el) { var q = rel(el); var e = { x: q.l - 6, y: q.cy }; var cx = (Rc.x + e.x) / 2; return [Rc, { x: cx + 30, y: Rc.y }, { x: cx - 30, y: e.y }, e]; });
      }
      readPalette();
    }

    function bz(p, t) { var u = 1 - t; return { x: u * u * u * p[0].x + 3 * u * u * t * p[1].x + 3 * u * t * t * p[2].x + t * t * t * p[3].x, y: u * u * u * p[0].y + 3 * u * u * t * p[1].y + 3 * u * t * t * p[2].y + t * t * t * p[3].y }; }
    function ease(t) { return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function flash(el) { if (!el) return; el.classList.add('is-hit'); setTimeout(function () { el.classList.remove('is-hit'); }, 500); }

    function spawnOrder() { if (!pathsL.length) return; parts.push({ kind: 'order', side: 'L', i: Math.floor(Math.random() * pathsL.length), t: 0, fw: true, v: (0.0036 + Math.random() * 0.002) * speed, trail: [], size: 3.5 + Math.random() * 1.5 }); }
    function spawnProduct() { if (!pathsR.length) return; parts.push({ kind: 'product', side: 'R', i: Math.floor(Math.random() * pathsR.length), t: 1, fw: false, v: (0.0036 + Math.random() * 0.002) * speed, trail: [], size: 3.5 + Math.random() * 2 }); }

    function drawStatic(intro) {
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = pal.grid; var g = 36;
      for (var gx = (W / 2) % g; gx < W; gx += g) for (var gy = (H / 2) % g; gy < H; gy += g) ctx.fillRect(gx, gy, 1.5, 1.5);
      var all = pathsL.concat(pathsR);
      ctx.lineCap = 'round'; ctx.lineWidth = 2; ctx.strokeStyle = pal.line;
      all.forEach(function (path) { ctx.beginPath(); var n = 40; ctx.moveTo(path[0].x, path[0].y); for (var k = 1; k <= n * intro; k++) { var q = bz(path, k / n); ctx.lineTo(q.x, q.y); } ctx.stroke(); });
      return all;
    }

    function frame(now) {
      if (!alive) return;
      raf = requestAnimationFrame(frame);
      /* maat veranderd zonder dat de ResizeObserver dat meldde (themabewerker, viewport-emulatie): opnieuw meten */
      if (root.clientWidth !== W || root.clientHeight !== H) layout();
      if (W < 1 || H < 1) return;
      if (!t0) { t0 = now; last = now; }
      var dt = Math.min(40, now - last); last = now;
      var t = (now - t0) / 1000;
      var intro = reduce ? 1 : Math.min(1, Math.max(0, (t - 0.2) / 1.4));

      var all = drawStatic(intro);
      if (reduce) return; /* alleen stilstaande lijnen */

      var rate = 560 / density;
      acc += dt; while (acc > rate && intro >= 1) { acc -= rate; spawnOrder(); spawnProduct(); }

      dashOff -= dt * 0.3 * speed;
      ctx.save(); ctx.globalCompositeOperation = pal.blend; ctx.setLineDash([26, 220]); ctx.lineDashOffset = dashOff;
      ctx.lineWidth = 2.5; ctx.strokeStyle = pal.comet; ctx.globalAlpha = 0.9 * intro; ctx.shadowColor = pal.comet; ctx.shadowBlur = pal.glow;
      all.forEach(function (p) { ctx.beginPath(); ctx.moveTo(p[0].x, p[0].y); ctx.bezierCurveTo(p[1].x, p[1].y, p[2].x, p[2].y, p[3].x, p[3].y); ctx.stroke(); });
      ctx.restore();

      /* producten (donker) eerst, orders (goud) erbovenop */
      parts.sort(function (p1, p2) { return (p1.kind === 'order') - (p2.kind === 'order'); });
      ctx.save(); ctx.globalCompositeOperation = pal.blend;
      for (var i = parts.length - 1; i >= 0; i--) {
        var a = parts[i]; var step = a.v * (dt / 16.7); a.t += a.fw ? step : -step;
        var tt = Math.max(0, Math.min(1, a.t));
        var path = a.side === 'L' ? pathsL[a.i] : pathsR[a.i];
        if (!path) { parts.splice(i, 1); continue; }
        var pos = bz(path, ease(tt));
        a.trail.push(pos); if (a.trail.length > 12) a.trail.shift();
        var isOrder = a.kind === 'order', col = isOrder ? pal.order : pal.product;
        for (var k = 0; k < a.trail.length; k++) { var q = a.trail[k], f = (k + 1) / a.trail.length; ctx.globalAlpha = f * f * 0.5; ctx.fillStyle = col; ctx.beginPath(); ctx.arc(q.x, q.y, a.size * f * 0.9, 0, 6.283); ctx.fill(); }
        var nearLogo = a.side === 'L' ? (1 - tt) : tt;
        ctx.globalAlpha = Math.max(0, Math.min(1, nearLogo / 0.16));
        ctx.fillStyle = col; ctx.shadowColor = col; ctx.shadowBlur = pal.glow;
        ctx.beginPath();
        if (isOrder) { ctx.arc(pos.x, pos.y, a.size, 0, 6.283); }
        else { var s = a.size * 1.6; if (ctx.roundRect) ctx.roundRect(pos.x - s / 2, pos.y - s / 2, s, s, 2); else ctx.rect(pos.x - s / 2, pos.y - s / 2, s, s); }
        ctx.fill(); ctx.shadowBlur = 0;
        var done = a.fw ? a.t >= 1 : a.t <= 0;
        if (done) {
          parts.splice(i, 1);
          if (isOrder) {
            if (a.side === 'L') parts.push({ kind: 'order', side: 'R', i: Math.floor(Math.random() * pathsR.length), t: 0, fw: true, v: a.v, trail: [], size: a.size });
            else flash(rightTiles[a.i]);
          } else {
            if (a.side === 'R') parts.push({ kind: 'product', side: 'L', i: Math.floor(Math.random() * pathsL.length), t: 1, fw: false, v: a.v, trail: [], size: a.size });
            else flash(leftTiles[a.i]);
          }
        }
      }
      ctx.restore();
    }

    var ro = new ResizeObserver(function () { layout(); });
    ro.observe(root);
    window.addEventListener('resize', layout);
    var mo = new MutationObserver(readPalette);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme', 'class'] });
    root.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', layout, { once: true }); });

    layout();
    raf = requestAnimationFrame(frame);
    instances.set(root, function destroy() { alive = false; cancelAnimationFrame(raf); ro.disconnect(); mo.disconnect(); window.removeEventListener('resize', layout); });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-gg-stroom]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-gg-stroom]').forEach(function (r) { var d = instances.get(r); if (d) { d(); instances.delete(r); } });
  });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target.closest('.shopify-section') || document); });
})();
